import { apiClient } from "./api-client";
import { toArray } from "./api-utils";
import type { TriyoProjectTemplate } from "@/types/models";

export const ProjectTemplatesApi = {
  /** Templates offered on the Create Deal form (requires Project/Add or Project/Edit). */
  getTemplatesForProject: async (): Promise<TriyoProjectTemplate[]> => {
    const res = await apiClient.get<unknown>("/project-template/GetAllTemplatesForProject");
    return toArray<TriyoProjectTemplate>(res.data, "Templates", "templates");
  },

  /** The tenant's default template, or null when none is configured. */
  getDefaultTemplate: async (): Promise<TriyoProjectTemplate | null> => {
    const res = await apiClient.get<TriyoProjectTemplate | null>("/project-template/GetDefaultTemplate");
    return res.data && typeof res.data === "object" ? res.data : null;
  },
};
